/**
 * Draggable floating WhatsApp button (.static-wa-btn / #static-wa-btn).
 * - Drag with mouse or touch (Pointer Events).
 * - A small movement threshold keeps normal taps/clicks working as a link.
 * - Last position is remembered in localStorage and re-clamped to the viewport.
 *
 * Self-contained and defensively guarded: any failure is caught so it can
 * never break the rest of the page. Loaded with `defer`, so the DOM is ready.
 */
(function () {
  'use strict';

  try {
    var btn = document.getElementById('static-wa-btn');
    if (!btn) return;

    var STORAGE_KEY = 'waBtnPos';
    var DRAG_THRESHOLD = 6; // px moved before it counts as a drag (vs a click)

    function clamp(val, min, max) {
      return Math.max(min, Math.min(max, val));
    }

    // Apply a saved {left, top} position, clamped to the current viewport.
    function applySaved() {
      var raw;
      try { raw = localStorage.getItem(STORAGE_KEY); } catch (e) { return; }
      if (!raw) return;
      var pos;
      try { pos = JSON.parse(raw); } catch (e) { return; }
      if (!pos || typeof pos.left !== 'number' || typeof pos.top !== 'number') return;
      var maxLeft = window.innerWidth - btn.offsetWidth;
      var maxTop = window.innerHeight - btn.offsetHeight;
      btn.style.left = clamp(pos.left, 0, maxLeft) + 'px';
      btn.style.top = clamp(pos.top, 0, maxTop) + 'px';
      btn.style.right = 'auto';
      btn.style.bottom = 'auto';
    }

    var startX, startY, originLeft, originTop, dragging, moved, pointerId;

    function onPointerDown(e) {
      if (e.button != null && e.button !== 0) return; // left click / touch only
      var rect = btn.getBoundingClientRect();
      originLeft = rect.left;
      originTop = rect.top;
      startX = e.clientX;
      startY = e.clientY;
      dragging = true;
      moved = false;
      pointerId = e.pointerId;
      try { btn.setPointerCapture(pointerId); } catch (err) {}
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (!moved && Math.abs(dx) + Math.abs(dy) < DRAG_THRESHOLD) return;
      moved = true;
      btn.classList.add('is-dragging');
      var maxLeft = window.innerWidth - btn.offsetWidth;
      var maxTop = window.innerHeight - btn.offsetHeight;
      var left = clamp(originLeft + dx, 0, maxLeft);
      var top = clamp(originTop + dy, 0, maxTop);
      btn.style.left = left + 'px';
      btn.style.top = top + 'px';
      btn.style.right = 'auto';
      btn.style.bottom = 'auto';
      e.preventDefault();
    }

    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      btn.classList.remove('is-dragging');
      try { btn.releasePointerCapture(pointerId); } catch (err) {}
      if (moved) {
        var rect = btn.getBoundingClientRect();
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify({ left: rect.left, top: rect.top }));
        } catch (err) {}
      }
    }

    // If a drag happened, swallow the click so it doesn't open the link.
    btn.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        moved = false;
      }
    });

    btn.addEventListener('pointerdown', onPointerDown);
    btn.addEventListener('pointermove', onPointerMove);
    btn.addEventListener('pointerup', onPointerUp);
    btn.addEventListener('pointercancel', onPointerUp);
    btn.addEventListener('dragstart', function (e) { e.preventDefault(); });

    applySaved();
    window.addEventListener('resize', applySaved);
  } catch (err) {
    if (window.console && console.warn) {
      console.warn('wilco-wa-btn: init failed', err);
    }
  }
})();
